<template>
    <div class="search-box">
        <el-input placeholder="手机号/姓名首字母/姓名/卡号" v-model="searchValue"
                  @keypress.native="e => {if(e.charCode === 13) searchUser();}">
            <el-button slot="append" type="primary" @click="searchUser">查找会员</el-button>
        </el-input>
        <transition name="el-zoom-in-top">
            <pop-select :field-data="selectField" :select-data="selectData" v-if="isShowSelect" :width="680"
                        @select="selected" show-overflow-tooltip
            ></pop-select>
        </transition>
    </div>
</template>

<script>
    import obj from "@/js/obj";
    import PopSelect from "@/model/PopSelect";
    export default {
        name: "SearchUser",
        components: {PopSelect},
        data: () => ({
            isShowSelect: false,
            selectField: {
                name: "姓名",
                mobile: "联系电话",
                vip_name: "会员等级",
                money: "余额",
                no: "卡号",
            },
            selectData: [
                // {
                //     id: 1,
                //     nickname: "张三",
                //     mobile: "13800138000",
                //     vip_name: "黄金会员",
                //     money: "1002.00"
                // }
            ],
            searchValue: ""
        }),

        watch: {
            isShowSelect: function (newData) {
                if(newData){
                    $("body").one("click", this.clickEvent.bind(this));
                }
            }
        },

        methods: {
            selected: function (data) {
                this.$emit("searched", data);
                this.isShowSelect = false;
            },
            searchUser: function () {
                obj.postData("cash/search_store_user", {keyword: this.searchValue}, function (res) {
                    if(res.errcode === 0){
                        this.selectData = res.data;
                    }else{
                        this.selectData = [];
                    }
                    this.isShowSelect = true;
                }.bind(this));
            },
            enterEvent: function (e) {
                if(e.charCode === 13)
                    this.searchUser();
            },
            clickEvent: function (e) {
                if(e.target.className.match(/mCSB/))
                    $("body").one("click", this.clickEvent.bind(this));
                else
                    this.isShowSelect = false;
            },
            clearSearchValue: function () {
                this.searchValue = "";
            }
        }
    }
</script>

<style scoped>
    .search-box{
        width: 380px;
        display: inline-block;
    }
</style>
